import { LinkedList } from './LinkedList';

interface LRUCacheItem<T> {
	item: T;
	key: string;
	maxage: number;
}

export interface LRUCacheOptions {
	maxage?: number;
	maxlength?: number;
}

export class LRUCache<T> {
	private list: LinkedList<LRUCacheItem<T>>;
	private maxage: number;
	private maxlength: number;

	constructor(options: LRUCacheOptions = { maxage: 0, maxlength: 5 }) {
		this.list = new LinkedList<LRUCacheItem<T>>();
		const { maxage = 0, maxlength = 5 } = options;
		this.maxage = maxage;
		this.maxlength = maxlength;
	}

	public get keys(): string[] {
		return this.list.map((v) => v.key).toArray();
	}

	public get length(): number {
		return this.list.length;
	}

	public add(key: string, item: T): void {
		const { list, maxage, maxlength } = this;
		if (list.length >= maxlength) {
			list.removeElementAtIndex(list.length - 1);
		}
		list.add({ item, key, maxage }, 0);
	}

	public get(key: string): T | undefined {
		const { list, keys } = this;
		const idx = keys.indexOf(key);
		const ele = list.elementAtIndex(idx);
		// move element to front
		if (ele) {
			list.removeElementAtIndex(idx);
			list.add(ele, 0);
		}
		return ele && ele.item;
	}

	public has(key: string): boolean {
		const { keys } = this;
		const idx = keys.indexOf(key);
		return idx > -1;
	}
}
